import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { Caller, CallerInput } from '@/models/caller';

export const updateCaller = async ({
  callerId,
  data,
  partnerId,
}: {
  callerId: string;
  data: CallerInput;
  partnerId?: number;
}) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      data,
      partnerId,
    },
    mutation: graphql(`
      mutation UpdateCaller($callerId: String, $data: CallerInputType!, $partnerId: Float) {
        updateCaller(callerId: $callerId, data: $data, partnerId: $partnerId) {
          ...CallerFragment
        }
      }
    `),
  });

  return response.data?.updateCaller as Caller;
};
